import React from 'react';
import { Spinner } from '@/components/ui';
import type {
  WidgetMetadata,
  WidgetContext,
  WidgetHelpers,
} from './ParentWidget';

export interface KPIData {
  value: number;
  description: string;
}

export interface KPIBodyProps {
  data?: KPIData;
  metadata: WidgetMetadata;
  context: WidgetContext;
  helpers: WidgetHelpers<KPIData>;
}

const KPIBody: React.FC<KPIBodyProps> = ({
  data,
  metadata,
}) => {
  if (metadata.loading) {
    return (
      <div className="tw-flex tw-items-center tw-pt-2">
        <Spinner animation="border" size="sm" className="tw-mr-2" role="status">
          <span className="tw-sr-only">Loading...</span>
        </Spinner>
        <span className="tw-text-content-muted tw-text-sm">Loading...</span>
      </div>
    );
  }

  if (metadata.error) {
    return (
      <div className="tw-text-danger tw-text-sm tw-pt-2">
        {metadata.error.message || 'An error occurred'}
      </div>
    );
  }

  if (metadata.isEmpty) {
    return (
      <div>
        <div className="tw-font-display tw-text-[2.25rem] tw-font-bold tw-leading-none tw-text-line">—</div>
        <div className="tw-text-content-muted tw-text-xs tw-mt-1.5 tw-leading-snug tw-line-clamp-2 kpi-description">No data</div>
      </div>
    );
  }

  const value = data?.value ?? 0;
  const description = data?.description ?? '';

  return (
    <div>
      <div className="tw-font-display tw-text-[2.25rem] tw-font-bold tw-leading-none tw-tracking-tight tw-tabular-nums tw-text-ink kpi-value">
        {value.toLocaleString()}
      </div>
      <div className="tw-text-content-muted tw-text-xs tw-mt-1.5 tw-leading-snug tw-line-clamp-2 kpi-description">
        {description}
      </div>
    </div>
  );
};

export default KPIBody;
